// types and classes
import { RouteComponentProps } from '@reach/router';

import Button from '@mui/material/Button';
import { Debug, ArrayField, Form, Input } from 'informed';
import RenderedQuestionInstance from '../components/common/QuoteComponents/RenderedQuestionInstance';
import { QuoteWizardQuestionInstance } from '../components/QuoteWizard/classes';
import { v4 as createId } from 'uuid';

interface TestingProps extends RouteComponentProps {}
/**
 * Component to test new components, &c.
 */
export const Testing = (_props: TestingProps) => {
  return (
    <Form>
      {/* <ArrayFieldTest /> */}
      <RenderedQuestionInstanceTest />
      <Debug />
    </Form>
  );
};

const RenderedQuestionInstanceTest = () => {
  const questionInstances: Array<QuoteWizardQuestionInstance> = [
    new QuoteWizardQuestionInstance({
      id: createId(),
      apiName: 'test_repeatable',
      displayName: 'Test Repeatable',
      component: 'repeatable',
      label: 'Test Repeatable Field',
      helpText: null,
      dataType: 'nested',
      propsBlob: { repeatable: true },
      subQuestions: [
        new QuoteWizardQuestionInstance({
          id: createId(),
          apiName: 'test_textfield',
          displayName: 'Test Textfield',
          component: 'textfield',
          label: 'Test Text Input',
          helpText: null,
          dataType: 'string',
          propsBlob: {},
          subQuestions: [],
        }),
      ],
    }),
  ];
  return (
    <>
      <p>rendered question instances</p>
      {questionInstances.map((q) => (
        <RenderedQuestionInstance questionInstance={q} key={q.id} />
      ))}
    </>
  );
};

// @ts-expect-error
const ArrayFieldTest = () => {
  return (
    <ArrayField name='test'>
      {({ add }) => {
        return (
          <>
            <ArrayField.Items>
              {() => {
                return <ArrayFieldItemComponent />;
              }}
            </ArrayField.Items>
            <Button onClick={() => add()}>Add</Button>
          </>
        );
      }}
    </ArrayField>
  );
};

const ArrayFieldItemComponent = () => {
  return (
    <>
      <Input name='inner' />
      <InnerArrayFieldTest />
    </>
  );
};

const InnerArrayFieldTest = () => {
  return (
    <ArrayField name='inner array field'>
      {({ add }) => {
        return (
          <>
            <ArrayField.Items>
              {() => {
                return <InnerArrayFieldItemComponent />;
              }}
            </ArrayField.Items>
            <Button onClick={() => add()}>Add Inner</Button>
          </>
        );
      }}
    </ArrayField>
  );
};

const InnerArrayFieldItemComponent = () => {
  return <Input name='inner text field' />;
};
